"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var agGridAngular_1 = require("./agGridAngular");
var agGridColumn_1 = require("./agGridColumn");
var ɵngcc0 = require('@angular/core');
var ɵngcc1 = require('./agGridAngular');
var ɵngcc2 = require('./agGridColumn');
var AgGridModule = /** @class */ (function () {
    function AgGridModule() {
    }
    AgGridModule.withComponents = function (components) {
        return {
            ngModule: AgGridModule,
            providers: [
                { provide: core_1.ANALYZE_FOR_ENTRY_COMPONENTS, useValue: components, multi: true }
            ],
        };
    };
    AgGridModule.forRoot = function (components) {
        return {
            ngModule: AgGridModule,
            providers: [
                { provide: core_1.ANALYZE_FOR_ENTRY_COMPONENTS, useValue: components, multi: true }
            ],
        };
    };
    /** @nocollapse */
    AgGridModule.ctorParameters = function () { return []; };
AgGridModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: AgGridModule });
AgGridModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function AgGridModule_Factory(t) { return new (t || AgGridModule)(); }, imports: [[]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AgGridModule, { declarations: [ɵngcc1.AgGridAngular, ɵngcc2.AgGridColumn], exports: [ɵngcc1.AgGridAngular, ɵngcc2.AgGridColumn] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AgGridModule, [{
        type: core_1.NgModule,
        args: [{
                imports: [],
                declarations: [
                    agGridAngular_1.AgGridAngular,
                    agGridColumn_1.AgGridColumn
                ],
                exports: [
                    agGridAngular_1.AgGridAngular,
                    agGridColumn_1.AgGridColumn
                ]
            }]
    }], function () { return []; }, null); })();
    return AgGridModule;
}());
exports.AgGridModule = AgGridModule;

//# sourceMappingURL=aggrid.module.js.map